import axios from 'axios';
import { API_CORE_URL } from '../constantes/constantes';

/**
 * Obtiene la información de las ligas por sus IDs.
 *
 * @param {string|string[]} ids - ID o arreglo de IDs de las ligas a consultar.
 *                                  Ej: '1' o ['1', '2', '3'] o '1,2,3'
 * @returns {Promise<{ data: any, statusCode: number }>} Objeto con los datos de las ligas o estado del error.
 */
export async function getLigaTV(ids) {
  try {
    // Convertir ids a string si es un arreglo
    const idsString = Array.isArray(ids) ? ids.join(',') : ids;

    const url = `${API_CORE_URL}events/leagues/today`;
    // const url = `https://api.amxinfra.com/api/core-clarosports/v2/events-by-filters?date=2026-10-14&timezone=America%2FMexico_City`;

    const { data, status } = await axios.get(url, {
      timeout: 25000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json; charset=utf-8',
      },
      params: {
        ids: idsString,
      },
    });

    // console.log(" data: ", data.sports[0].leagues)
    // data = data.sports[0].leagues;
    return { statusCode: status, data};
  } catch (error) {
    console.error('Error en la petición getLigaTV:', error.message || error);

    const status = error.response?.status || 500;
    return { statusCode: status, data: [] };
  }
}
